import React from 'react'
import { Loader } from './loader'

export const FullPageLoader = function () {
  return (
    <div className="flex-row flex-center-items full-view-height">
      <Loader />
    </div>
  )
}
